import React from "react";

import TextureUpload from "../ui/TextureUpload";

import { TextureType } from "../materials/TextureLoader";

export default function PBRControls({
  Slider,

  metallic,
  setMetallic,

  metallicMap,
  setMetallicMap,

  roughness,
  setRoughness,

  roughnessMap,
  setRoughnessMap,
}) {
  return (
    <>
      <Slider
        label="Metallic"
        value={metallic}
        min={0}
        max={1}
        step={0.01}
        display={metallic.toFixed(2)}
        onChange={setMetallic}
      />

      <TextureUpload
        label="Metallic Map"
        texture={metallicMap}
        type={TextureType.DATA}
        onChange={setMetallicMap}
      />

      <Slider
        label="Roughness"
        value={roughness}
        min={0.045}
        max={1}
        step={0.01}
        display={roughness.toFixed(2)}
        onChange={setRoughness}
      />

      <TextureUpload
        label="Roughness Map"
        texture={roughnessMap}
        type={TextureType.DATA}
        onChange={setRoughnessMap}
      />
    </>
  );
}
